(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kowua-payback"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kowua-payback')) {
  customElements.define('kowua-payback', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('input', (event) => {
        if (!event.target.matches('[data-charge]')) return;
        const input = event.target;
        const amount = input.valueAsNumber;
        this.querySelectorAll('[data-charge]').forEach((field) => {
          if (field !== input) field.value = input.value;
        });
        this.querySelectorAll('[data-result]').forEach((output) => {
          const valid = Number.isFinite(amount) && amount >= 0.01 && input.validity.valid;
          if (!valid) {
            output.textContent = input.value === '' && !input.validity.badInput ? output.dataset.empty : output.dataset.invalid;
            return;
          }
          const count = Math.ceil(Number(output.dataset.price) / (amount * 100));
          output.textContent = Number.isSafeInteger(count)
            ? output.dataset.template.replace('__COUNT__', new Intl.NumberFormat(this.dataset.locale).format(count))
            : output.dataset.invalid;
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kowua-treatment-routes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kowua-route-selector')) {
  customElements.define('kowua-route-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const controls = this.querySelector('.kwtr__choices');
      const buttons = [...this.querySelectorAll('[data-route]')];
      const panels = [...this.querySelectorAll('[data-route-panel]')];
      const select = (id) => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.route === id)));
        panels.forEach(panel => panel.hidden = panel.dataset.routePanel !== id);
      };
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.route)));
      if (buttons.length) {
        select(buttons[0].dataset.route);
        controls.hidden = false;
        this.classList.add('kwtr--interactive');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
